import { memo } from 'react';
import { useFrame } from '$shared/utils';
import styles from './n61-footer.module.css';
import { RichTextArea } from '../components/rich-text-area/rich-text-area.component';
import { MenuArea } from '../components/menu-area/menu-area.component';
import { NewsletterArea } from '../components/newsletter-area/newsletter-area.component';
import { IconArea } from '../components/icon-area/icon-area.component';
import { N80Trustpilot } from '../../n80-trustpilot/n80-trustpilot.component';
import { RawHtml, Typography } from '~/shared/components';

export const N61Footer = memo(() => {
    const { data: frame } = useFrame();

    const {
        contactText,
        menu,
        newsletterText,
        newsletterLink,
        additionalIcons,
        socialLinks,
        footerMeta,
        copyrights,
    } = frame?.footer || {};

    const showGrid = menu || contactText || newsletterText || newsletterLink;

    return (
        <footer className={styles.root}>
            {frame?.footer?.trustpilotWidgetSnippet && (
                <div className={styles.trustpilotWrapper}>
                    <N80Trustpilot markup={frame?.footer?.trustpilotWidgetSnippet} />
                </div>
            )}
            {showGrid && (
                <div className={styles.grid}>
                    <RichTextArea text={contactText} socialLinks={socialLinks} />
                    {menu && <MenuArea menu={menu} />}
                    {newsletterText || newsletterLink ? (
                        <NewsletterArea text={newsletterText} link={newsletterLink} />
                    ) : null}
                </div>
            )}

            {footerMeta && (
                <div className={styles.metaArea}>
                    <RawHtml html={footerMeta} linkStrokeMode="whileHover" />
                </div>
            )}
            <div className={styles.subFooter}>
                <IconArea
                    paymentIcons={frame?.ecommerce?.paymentIcons}
                    additionalIcons={additionalIcons}
                />
                <Typography variant="bodysm">{copyrights}</Typography>
            </div>
        </footer>
    );
});
